import {
  ApiBlobGetRequest,
  ApiGetRequest,
  ApiPostRequest,
  //   ApiDeleteRequest,
  ApiPutRequest,
} from '../../../api';
// import { _ } from 'vue-underscore';
import { showNotif } from '../../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Invoice Penjualan',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Invoice Penjualan',
        href: '/adm/fin/penjualan/invoice',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_jual',
    sortDesc: true,
    fields: [
      {
        key: 'code_jual',
        label: 'Kode',
      },
      {
        key: 'principle',
        label: 'Principle',
      },
      {
        key: 'tgl_jual',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'type_sale',
        label: 'Jenis',
        sortable: true,
      },
      {
        key: 'down_payment',
        label: 'DP',
      },
      {
        key: 'total_payment',
        label: 'Total Final',
      },
      {
        key: 'status_jual',
        label: 'Status',
      },
      {
        key: 'payment',
        label: 'Bayar',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_choose: [
      {
        key: 'code_jual',
        label: 'Kode',
      },
      {
        key: 'principle',
        label: 'Principle',
      },
      {
        key: 'tgl_jual',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'total_invoice',
        label: 'Total',
      },
    ],
    journal: false,
    row_item: {
      description: '',
      id_product: '',
      item_acc: '',
      item_order: '',
      item_send: '',
      id_satuan: '',
      item_price: '',
      item_disc: '',
      item_disc_nominal: '',
      item_acc_disc: '',
      item_id_pajak: '',
      item_acc_tax: '',
      item_tax: '',
      item_persentase: 0,
      item_total: 0,
    },
    form: {
      code_jual: '',
      id_principle: '',
      principle_code: '',
      principle_name: '',
      tgl_jual: '',
      tgl_faktur: '',
      tgl_kirim: '',
      id_currency: '',
      id_department: '',
      id_gudang: '',
      type_sale: 0,
      type_payment: 0,
      remark: '',
      term_payment: '',
      memo: '',
      other_cost: '',
      acc_other_cost: '',
      acc_other_cost_code: '',
      acc_other_cost_name: '',
      total_pajak: '',
      total_invoice: '',
      down_payment: '',
      id_um_jual: '',
      total_payment: '',
      acc_total_payment: '',
      acc_total_payment_code: '',
      acc_total_payment_name: '',
      status_jual: '',
      id_journal: '',
      id_sales: '',
      sales_code: '',
      sales_name: '',
      items: [
        {
          description: '',
          id_product: '',
          item_acc: '',
          item_order: '',
          item_send: '',
          id_satuan: '',
          item_price: '',
          item_disc: '',
          item_disc_nominal: '',
          item_acc_disc: '',
          item_id_pajak: '',
          item_acc_tax: '',
          item_tax: '',
          item_persentase: 0,
          item_total: 0,
        },
      ],
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  journal(state) {
    return state.data.journal;
  },
};

export const mutations = {
  changeInvPenjualan(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
  resetForm(state) {
    state.data = Object.assign({}, state.data, {
      form: {
        code_jual: '',
        id_principle: '',
        principle_code: '',
        principle_name: '',
        tgl_jual: '',
        tgl_faktur: moment().format('DD/MM/YYYY'),
        tgl_kirim: '',
        id_currency: '',
        id_department: '',
        id_gudang: '',
        type_sale: 0,
        type_payment: 0,
        remark: '',
        term_payment: '',
        memo: '',
        other_cost: '',
        acc_other_cost: '',
        acc_other_cost_code: '',
        acc_other_cost_name: '',
        total_pajak: '',
        total_invoice: '',
        down_payment: '',
        id_um_jual: '',
        total_payment: '',
        acc_total_payment: '',
        acc_total_payment_code: '',
        acc_total_payment_name: '',
        status_jual: '',
        id_journal: '',
        id_sales: '',
        sales_code: '',
        sales_name: '',
        id_pkp: '',
        pkp: '',
        id_pkp_cabang: '',
        pkp_cabang: '',
        id_type_payment: '',
        items: [
          {
            description: '',
            id_product: '',
            item_acc: '',
            item_order: '',
            item_send: '',
            id_satuan: '',
            item_price: '',
            item_disc: '',
            item_disc_nominal: '',
            item_acc_disc: '',
            item_id_pajak: '',
            item_acc_tax: '',
            item_tax: '',
            item_persentase: 0,
            item_total: 0,
          },
        ],
      },
    });
  },
};

export const actions = {
  async getLastNoFaktur({ commit, state }) {
    commit('changeInvPenjualan', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`logistic/penjualan/last-id`);
    commit('changeInvPenjualan', {
      form: {
        ...data.form,
        code_jual: result.data.object,
      },
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getListPenjualan({ commit, state }, payload = {}) {
    commit('changeInvPenjualan', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...payload,
      start_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[0]
          ? moment(payload.date_filter[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 1 &&
        payload.date_filter[1]
          ? moment(payload.date_filter[1]).format('YYYY-MM-DD')
          : '',
    };

    if (data.type_sale === 1 || data.type_sale === 0) {
      params.type_sale = data.type_sale;
    }

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`logistic/penjualan`, params);
      commit('changeInvPenjualan', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_invoice_penjualan.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    } else {
      let result = await ApiGetRequest(`logistic/penjualan`, params);
      commit('changeInvPenjualan', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getJournalInvoice({ commit }, payload = null) {
    commit('changeInvPenjualan', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `logistic/penjualan/${payload.id}/journal`
    );
    commit('changeInvPenjualan', {
      loading: false,
    });

    if (!result.error) {
      commit('changeInvPenjualan', {
        journal: result.data.object,
      });
    }

    return !result.error ? true : false;
  },

  async getDetailOrderJual({ commit }, payload = null) {
    commit('changeInvPenjualan', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(
      `logistic/penjualan/order-jual/${payload.id}`
    );
    commit('changeInvPenjualan', {
      loading: false,
    });

    if (!result.error) {
      let data_object = result.data.object;
      delete data_object.tgl_faktur;

      commit('changeInvPenjualan', {
        form: {
          ...data.form,
          ...data_object,
          type_sale: +data_object.type_sale,
          items: data_object ? data_object.items : [data.row_item],
        },
      });
    }

    return !result.error ? true : false;
  },

  async getDetailPenjualan({ commit, state }, payload = null) {
    commit('changeInvPenjualan', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`logistic/penjualan/${payload.id}`);
    commit('changeInvPenjualan', {
      loading: false,
    });

    if (!result.error) {
      commit('changeInvPenjualan', {
        detail: result.data.object,
        form: {
          ...data.form,
          ...result.data.object,
          pkp: result.data.object.pkp ? result.data.object.pkp : '',
          sales_name: result.data.object.sales_name
            ? result.data.object.sales_name
            : '',
          tgl_kirim: result.data.object.tgl_kirim
            ? moment(result.data.object.tgl_kirim).format('DD/MM/YYYY')
            : '',
          type_sale:
            result.data.object.type_sale &&
            parseInt(result.data.object.type_sale) > 0
              ? 1
              : 0,
          type_payment:
            result.data.object.type_payment &&
            parseInt(result.data.object.type_payment) > 0
              ? 1
              : 0,
        },
      });
    }

    return !result.error ? true : false;
  },

  async createPenjualan({ commit, state, dispatch }) {
    commit('changeInvPenjualan', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest('logistic/penjualan', data.form);

    commit('changeInvPenjualan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async updatePenjualan({ commit, state, dispatch }, payload = null) {
    commit('changeInvPenjualan', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(
      `logistic/penjualan/${payload.id}`,
      data.form
    );

    commit('changeInvPenjualan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },
};
